import ManageUsersPage from "./ManageUsersPage";

export default ManageUsersPage;
